import { Button } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../Translations';
import { ConnectionResource, diagnosedFields } from '../../Types';

interface Props {
  resource: ConnectionResource;
  onOpenDiagnostics: () => void;
}

const AttributesCard: React.FC<Props> = ({ resource, onOpenDiagnostics }) => (
  <div>
    <h3 className="text-base font-semibold text-foreground">
      <T kind="Attributes" />
    </h3>
    <div className="mt-3 rounded-lg border border-border bg-card p-6">
      <p className="text-sm text-muted-foreground">
        <T kind="How claims from your IdP map to ExecOnline profiles. If your IT team changes claims on their side, run diagnostics to re-check." />
      </p>
      <div className="mt-4 overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr>
              <th className="border-b border-border py-2 pr-3 text-left text-sm font-bold text-foreground">
                <T kind="ExecOnline field" />
              </th>
              <th className="border-b border-border py-2 text-left text-sm font-bold text-foreground">
                <T kind="SAML claim" />
              </th>
            </tr>
          </thead>
          <tbody>
            {diagnosedFields.map((diagnosed) => {
              const claims = resource.payload.attributeMapping
                .filter((entry) => entry.field === diagnosed.field)
                .map((entry) => entry.claim);

              return (
                <tr key={diagnosed.field}>
                  <td className="border-b border-border py-3 pr-3 text-sm font-medium text-foreground">
                    <T kind={diagnosed.label} />
                  </td>
                  <td className="border-b border-border py-3">
                    {claims.length > 0 ? (
                      <span className="break-all font-mono text-xs text-foreground">
                        {claims.join(', ')}
                      </span>
                    ) : (
                      <span className="text-sm text-muted-foreground">
                        <T kind="Not mapped" />
                      </span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="mt-4">
        <Button
          color="primary"
          variant="outlined"
          size="sm"
          onClick={onOpenDiagnostics}
          data-intercom-target="sso-open-attribute-diagnostics-button"
        >
          <T kind="Open attribute diagnostics" />
        </Button>
      </div>
    </div>
  </div>
);

export default observer(AttributesCard);
